<template>
  <div class="search-info d-none" v-if="getFilters.themeWords || getFilters.textSearch">
    {{$t('tuka.search.theme_word_filtered')}}
    <div class="themeWords" v-if="getFilters.themeWords">
    {{$t('tuka.search.theme_words')}}
      <span 
        v-for="(active, name) in themeWords"
        :class="active ? 'active' : ''"
        v-if="active"
      >
      {{name}}
      </span>
    </div>
    <button
      @click="clearFilters()"
    >
    {{$t('tuka.search.theme_word_filter_clear')}}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SearchInfo",
  props: [],
  computed: {
    ...mapGetters(["themeWords", "getFilters"]),
  },
  methods: {
    ...mapActions(["setThemeWords"]),
    clearFilters() {

      // Create copy of route info 
      let newRoute = {
        name: this.$router.currentRoute.name,
        params: {...this.$router.currentRoute.params},
        query: {...this.$router.currentRoute.query},
        hash: this.$router.currentRoute.hash
      }

      // Remove themeword from new query
      if (newRoute.query.themeword && newRoute.query.themeword.length) {
        delete newRoute.query['themeword'];
      }

      this.$router.push(newRoute).catch(err => { console.log("Reroute to same location, avoiding")});
    }
  },
  created() {},
};
</script>

<style lang="scss" scoped>

</style>